import { Component, OnInit } from '@angular/core';

import { MaterialModule } from '../../../../../assets/material/material.module';
import { SharedModule } from '../../../shared/shared.module';
import { ModalView } from '../../../../models/event-data.model';
import { EventTrackingService } from '../../../../services/event-tracking.service';
import { AuthEventRepo, AuthEventType } from '../../../../enums/event/event.enum';

@Component({
    selector: 'app-sunset-modal',
    imports: [MaterialModule, SharedModule],
    templateUrl: './sunset-modal.component.html',
    styleUrls: ['./sunset-modal.component.scss']
})
export class SunsetModalComponent implements OnInit {
  step: number;

  constructor(private readonly eventTrackingService: EventTrackingService) {}

  trackEvent() {
    this.eventTrackingService.trackEvent<ModalView>(AuthEventType.MODAL_VIEW, {
      eventRepo: AuthEventRepo.CustomerPortal,
      customerPortalDisplayText: 'The Best Egg Card App is going away on Dec 31st',
      customerPortalDisplayType: 'sunsetModal',
      siteSection: 'hub',
      product: 'CREDIT_CARD',
      cswPageName: null,
    });
  }

  ngOnInit(): void {
    this.trackEvent();
  }

  setStep(index: number) {
    this.step = this.step !== index ? index : undefined;
  }
}
